import { EstimateWithComponentsDto } from "../../../shared/dtos/estimate-with-components.dto";

export interface InvoiceDto {
  id: number;
  companyId: number;
  companyInvoiceId: number;
  workOrderId: number;
  status: InvoiceStatusType;
  amountPaid?: number | null;
  // SQ-429: every payment recorded on the invoice, oldest first (a single
  // invoice only; the lists leave it out). amountPaid is their total.
  payments?: InvoicePaymentDto[] | null;
  // SQ-429: when a receipt last went out; null until the first.
  receiptSentAt?: string | null;
  // SQ-401: the live job (an invoice is edited through it); the total and
  // the address come from here.
  estimate: EstimateWithComponentsDto;
  sentAt?: string | null;
  // SQ-687: stamped at the first send (send time + dueDays, UTC, possibly
  // with no zone mark) and never moved; null until then.
  dueAt?: string | null;
  dueDays?: number | null;
  // SQ-688: follow-up emails booked at the first send, days after dueAt
  // ([] when none), and when they were stopped on this invoice.
  followUpDays?: number[] | null;
  followUpsStoppedAt?: string | null;
  // SQ-688: the company's invoice follow-ups switch; off, none go out on any invoice.
  companyFollowUpsEnabled?: boolean;
  notes?: string;
  createdAt: string;
  createdBy: number;
  updatedAt: string;

  clientId: number;
  clientName: string;
  clientAddress: string;
  clientCity: string;
  clientState: string;
  clientPostalCode: string;
  clientEmail?: string;
  clientPhoneNumber?: string;
}

/** One payment recorded on an invoice (SQ-429: an invoice can be paid in parts). */
export interface InvoicePaymentDto {
  id: number;
  amount: number;
  createdBy: number;
  createdAt: string;
}

/**
 * SQ-625: one row of the invoices list (GET invoices/summaries): the client,
 * the status and the job's total, without the job graph InvoiceDto carries.
 * totalCost is 0 without invoices.view, like the record's.
 */
export interface InvoiceSummaryDto {
  id: number;
  companyId: number;
  companyInvoiceId: number;
  workOrderId: number;
  estimateId: number;
  status: InvoiceStatusType;
  amountPaid?: number | null;
  receiptSentAt?: string | null;
  sentAt?: string | null;
  // SQ-687: see InvoiceDto.
  dueAt?: string | null;
  dueDays?: number | null;
  totalCost: number;
  createdAt: string;
  createdBy: number;
  updatedAt: string;

  clientId: number;
  clientName: string;
  clientAddress: string;
  clientCity: string;
  clientState: string;
  clientPostalCode: string;
  clientEmail?: string | null;
  clientPhoneNumber?: string | null;
  // The job site (the estimate's address).
  jobAddress?: string | null;
  jobCity?: string | null;
  jobState?: string | null;
  jobPostalCode?: string | null;
}

export interface InvoiceUpdateDto {
  notes?: string;
}

export interface InvoiceStatusUpdateDto {
  status: InvoiceStatusType;
  amountPaid?: number | null;
}

export const InvoiceStatus = {
  Created: 'Created',
  Sent: 'Sent',
  Overdue: 'Overdue',
  Paid: 'Paid',
  Deleted: 'Deleted'
} as const;

export type InvoiceStatusType = typeof InvoiceStatus[keyof typeof InvoiceStatus];